// extracted by mini-css-extract-plugin
module.exports = {"root":"Question_root__2QrWB","question":"Question_question__1lXvP","description":"Question_description__3luUW"};